<template>
  <section class="all-cases-view">
    <div class="container-default">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table :data="getAllBatches.data" style="width: 100%">
            <el-table-column
              prop="batch_name"
              label="BATCH NAME"
              width="180"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column
              prop="case_type"
              label="CASE TYPE"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column label="PLATE TYPE" prop="plate">
              <template v-slot="scope">
                {{ scope.row.plate.split("_").join(" ") }}
              </template>
            </el-table-column>
            <el-table-column label="STATUS" prop="status">
              <template v-slot="scope">
                {{ scope.row.status.split("_").join(" ") }}
              </template>
            </el-table-column>
            <el-table-column
              prop="created_by"
              label="CREATED BY"
              width="300"
              sortable="custom"
            >
              <template #default="scope">
                <div>
                  <span>
                    {{ scope.row.created_by.first_name }}&{{
                      scope.row.created_by.last_name
                    }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="CREATED ON"
              width="150"
              sortable="custom"
            >
              <template #default="scope">
                <div>
                  <span>
                    {{ formatDate(scope.row.created_at) }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="ACTION">
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li @click="onClick(scope.row)">
                    <el-button class="view-button">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      class="view-button"
                      @click="onDeleteFile(scope.row)"
                      v-if="scope.row.status == 'COMPLETED'"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/delete-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/delete-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      class="view-button"
                      @click="downloadFile(scope.row)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/download-new.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[10, 25, 50, 100]"
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper, sizes, total"
              :total="getAllBatches.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  name: "hospital",
  data() {
    return {
      page: 1,
      pageSize: 25,
      loading: false,
    };
  },
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("batches", ["getAllBatches"]),
  },
  mounted() {
    this.fetchBatches();
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MM-DD-YYYY");
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchBatches();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchBatches();
    },
    async fetchBatches() {
      this.loading = true;
      await this.$store.dispatch("batches/fetchAllBatches", {
        limit: this.pageSize,
        page: this.page,
      });
      this.loading = false;
    },
  },
};
</script>
